import ActiveTeams from "_shared/teams/teams-active-page";
import { readTeamsTab } from "_shared/teams/teams-list-chips";
import { PageTab } from "_shared/teams/teams-tabs";
import TeamsTemplatesPage from "_shared/teams/teams-templates-page";
import { useParams } from "react-router";

/**
 * The Teams page (#6718): **Teams**, the teams on running work, and **Templates**, the teams a reader
 * keeps to start proposals from. A bare `/teams` opens the reader's own view of it, else Teams; the
 * route loader sends the page's retired tabs to the tab and chip each became.
 */
export default function Teams() {
  const { pageTab } = useParams();
  if (readTeamsTab(pageTab) === PageTab.Templates) return <TeamsTemplatesPage />;
  return <ActiveTeams />;
}
